import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAppearanceLightMode: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconAppearanceLightMode"><Path d="M12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16V8Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM12 8C14.2091 8 16 9.79086 16 12C16 14.2091 14.2091 16 12 16V20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4V8Z" fill="currentColor"/></CentralIconBase>;
});

export default IconAppearanceLightMode;
